export default __webpack_public_path__ + "static/media/archive.b8d7112d.jpg";